<template>
    <div class="data-wrapper">
        <div v-if="loaded" class="main-data-wrapper">
            <div class="avatars">
                <div class="main-avatar">
                    <ModelImg
                        label="Аватар"
                        v-model="profileInfo.avatar"
                        type="avatar"
                        :cropper="{
                            crop: true,
                            aspectRatio: '1:1',
                        }"
                    ></ModelImg>
                </div>
                <div class="official-avatar">
                    <ModelImg
                        label="Официальное фото"
                        v-model="profileInfo.avatarOfficial"
                        type="avatarOfficial"
                        :cropper="{
                            crop: true,
                            aspectRatio: '1:1',
                        }"
                    ></ModelImg>
                </div>
            </div>
            <div class="info" :class="{ full: !showBanner }">
                <div class="cols">
                    <div class="col-info">
                        <ModelString
                            label="Фамилия"
                            data-voicetext="Фамилия"
                            v-model="profileInfo.surname"
                            @error="errors = { ...errors, surname: $event }"
                            :invalidate-function="(val) => checkName(val, 'Фамилия')"
                        />

                        <ModelString
                            label="Имя"
                            data-voicetext="Имя"
                            v-model="profileInfo.name"
                            @error="errors = { ...errors, name: $event }"
                            :invalidate-function="(val) => checkName(val, 'Имя')"
                        />

                        <ModelString
                            label="Отчество"
                            data-voicetext="Отчество"
                            :disabled="profileInfo.isPatronymic"
                            v-model="profileInfo.patronymic"
                            @error="errors = { ...errors, patronymic: $event }"
                            :invalidate-function="
                                (val) => (!profileInfo.isPatronymic ? checkName(val, 'Отчество') : '')
                            "
                        />

                        <div class="chkbx">
                            <ModelCheckbox
                                v-model="profileInfo.isPatronymic"
                                @change="changeIsPatronymic"
                                label="Нет отчества"
                            />
                        </div>

                        <ModelISO
                            label="Дата рождения"
                            data-voicetext="Дата рождения"
                            v-model="profileInfo.dateOfBirth"
                            year-input-type="select"
                            :max-year="maxYear"
                            :min-year="minYear"
                            :validator="dateOfBirthValidator"
                        />
                    </div>
                    <div class="col-info">
                        <ModelSelect
                            label="Пол"
                            data-voicetext="Пол"
                            :items="getGendersDictionary"
                            item-value="is_man"
                            item-text="value"
                            v-model="profileInfo.gender"
                        />

                        <ModelSelect
                            label="Статус"
                            data-voicetext="Статус"
                            item-value="id"
                            item-text="field_value"
                            :items="dictionaryByType('user_status')"
                            v-model="profileInfo.foreignStatusId"
                        />

                        <ModelAutoComplete
                            :label="userProfileAge >= 18 ? 'Адрес проживания' : 'Город проживания'"
                            :data-voicetext="userProfileAge >= 18 ? 'Адрес проживания' : 'Город проживания'"
                            v-model="profileInfo.address"
                            :vizKeyPath="[['value']]"
                            :items="autoCompleteAddresses"
                            :error-message="addressErrorText"
                            @debounce-end="getAutocompleteAddress"
                            @selected="getFullAddress"
                            @clear="profileInfo.address = null"
                        />

                        <ModelMultiAutoComplete
                            v-if="showBanner"
                            label="Сфера деятельности"
                            data-voicetext="Сфера деятельности"
                            v-model="profileInfo.activity"
                            :items="autoCompleteActivity"
                            @debounce-end="getAutocompleteActivity"
                            item-value="id"
                            item-text="field_value"
                        />

                        <ModelTextArea data-voicetext="Обо мне" label="Обо мне" v-model="profileInfo.about" :maxlength="2500" counter />
                    </div>
                    <div class="col-info" v-if="!showBanner">
                        <ModelMultiAutoComplete
                            v-if="!showBanner"
                            label="Сфера деятельности"
                            data-voicetext="Сфера деятельности"
                            v-model="profileInfo.activity"
                            :search="autoCompleteActivity"
                            :selected="selectedActivity"
                            @debounce-end="getAutocompleteActivity"
                            item-value="id"
                            item-text="field_value"
                        />
                        <ModelInterests
                            v-if="allInterests.length"
                            label="Интересы и увлечения"
                            data-voicetext="Интересы и увлечения"
                            :search="autoCompleteInterests"
                            :selected="selectedInterests"
                            :max-length="60"
                            max-length-text-error="Достигнут лимит на количество символов"
                            :all-interests="allInterests"
                            :last-item="allInterests.slice(-1)[0]"
                            v-model="profileInfo.interests"
                            @debounce-end="getAutocompleteInterests"
                        />
                        <ModelInterests
                            v-if="allKeySkills.length"
                            label="Профессиональные навыки"
                            data-voicetext="Профессиональные навыки"
                            :search="autoCompleteKeySkills"
                            :selected="selectedKeySkills"
                            :max-length="60"
                            max-length-text-error="Достигнут лимит на количество символов"
                            :all-interests="allKeySkills"
                            :last-item="allKeySkills.slice(-1)[0]"
                            v-model="profileInfo.keySkills"
                            @debounce-end="getAutocompleteKeySkills"
                        />
                    </div>
                </div>
            </div>
            <div class="present" v-if="showBanner">
                <div class="present-awards-row">
                    <img src="../../../../assets/images/awards/1.svg" />
                    <img src="../../../../assets/images/awards/2.svg" />
                    <img src="../../../../assets/images/awards/3.svg" />
                </div>
                <div class="present-awards-row">
                    <img src="../../../../assets/images/awards/3.svg" />
                    <img src="../../../../assets/images/awards/1.svg" />
                    <img src="../../../../assets/images/awards/2.svg" />
                </div>
                <div class="present-awards-row">
                    <img src="../../../../assets/images/awards/3.svg" />
                    <img src="../../../../assets/images/awards/2.svg" />
                    <img src="../../../../assets/images/awards/1.svg" />
                </div>
            </div>
        </div>
        <FixedSaveBtn v-if="showFixedSaveBtn" @close="closeFixedBtn">
            <ActionButton
                @b-action="saveData"
                :b-color="saveButton.color"
                b-t-color="white"
                :b-text="saveButton.fixedText"
                class="save-block__btn--position save-block__btn"
                :disabled="hasErrors || isYearError()"
            />
        </FixedSaveBtn>
        <div class="save-block">
            <ActionButton
                ref="mainBtn"
                @b-action="saveData"
                :b-color="saveButton.color"
                b-t-color="white"
                :b-text="saveButton.text"
                class="save-block__btn--position save-block__btn"
                :disabled="hasErrors || isYearError()"
            />
        </div>

        <Dialog v-model="showBirthdayBanner" :scrollable="false" @close="$router.push({ name: 'account' })">
            <div class="birthdayBanner">
                <h1>
                    {{ profileInfo.name }},
                    <br />
                    вам уже исполнилось 18 лет?
                </h1>
                <p>
                    Укажите, пожалуйста, дату вашего рождения.<br />
                    Подтверждение возраста требуется для обработки персональных данных.
                </p>
                <ModelISO
                    label=""
                    v-model="profileInfo.dateOfBirth"
                    year-input-type="select"
                    :max-year="maxYear"
                    :min-year="minYear"
                    :validator="dateOfBirthValidator"
                />
                <ActionButton
                    @b-action="saveBirthday"
                    :b-color="birthdayBtnColor"
                    b-t-color="white"
                    :b-text="saveButton.text"
                    class="btn"
                />
            </div>
        </Dialog>
        <Dialog v-model="showSavingConfirmation" :scrollable="false" @close="savingConfirmation(false)">
            <div class="birthdayBanner">
                <h1>
                    Уверены, что хотите
                    <br />
                    изменить дату рождения?
                </h1>
                <p>
                    В соответствии с новыми данными вам меньше 18 лет.
                    <br />
                    И в таком случае в личном кабинете будет скрыта
                    <br />
                    часть персональных данных
                </p>
                <div class="buttons">
                    <Button class="btn-cancel" outline @click="savingConfirmation(false)">Отмена</Button>
                    <Button class="btn-success" @click="savingConfirmation(true)">Сохранить</Button>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script>
import Dialog from '../../../UI/Dialog';
import Button from '../../../UI/Button';
import ActionButton from '../../../UI/inputs/ActionButton';
import ModelImg from '../../../UI/models/ModelImg';

import ModelString from '../../../UI/models/ModelString';
import ModelSelect from '../../../UI/models/ModelSelect';

import ModelAutoComplete from '../../../UI/models/ModelAutoComplete';
import ModelMultiAutoComplete from '../../../UI/models/ModelMultiAutoComplete';
import ModelInterests from '../../../UI/models/ModelInterests';
import ModelISO from '../../../UI/models/ModelISO';
import ModelCheckbox from '../../../UI/models/ModelCheckbox';
import FixedSaveBtn from '../FixedSaveBtn';

import { get, post, qs } from '../../../../tools/http';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ModelTextArea from '../../../UI/models/ModelTextArea';
import ageFromDate, { dateOfBirthValidator, ageRating } from '@/tools/age';
import { checkName } from '@/tools/tools';

const getters = [
    'userProfileAge',
    'userProfileInfo',
    'userProfileName',
    'user',
    'user_img_stub',
    'dictionaryByType',
    'getGendersDictionary',
];

const mutations = ['setUserAvatar'];

const actions = [
    'loadProfileData',
    // "loadAuthData",
    'postProfileData',
    'loadDictionaryItems',
    'dictionaryAutocomplete',
    'getDictionaryItemById',
];

export default {
    name: 'WideMainData',
    data: () => ({
        showFixedSaveBtn: false,
        observer: null,
        showBanner: false,
        showBirthdayBanner: false,

        profileInfo: {
            name: '',
            surname: '',
            patronymic: '',
            isPatronymic: false,
            dateOfBirth: '',
            gender: null,
            address: '',
            activity: [],
            interests: [],
            keySkills: [],
            foreignStatusId: '',
            about: '',
            avatar: '',
            avatarOfficial: '',
        },
        loaded: false,
        errors: {},

        autoCompleteAddresses: [],
        autoCompleteActivity: [],
        selectedActivity: [],
        autoCompleteInterests: [],
        autoCompleteKeySkills: [],
        allInterests: [],
        allKeySkills: [],
        selectedInterests: [],
        selectedKeySkills: [],
        selectorActivity: [],
        saveButton: {
            fixedText: 'Сохранить изменения',
            text: 'Сохранить',
            color: '#4663AB',
            status: 'wait',
        },

        showSavingConfirmation: false,
        savingConfirmation: null,

        minYear: 1900,
        maxYear: new Date().getFullYear() - ageRating,
        dateOfBirthValidator: dateOfBirthValidator,
        addressErrorText: '',
    }),
    computed: {
        ...mapGetters(getters),

        birthdayBtnColor() {
            if (this.calcAge(this.profileInfo.dateOfBirth) !== null) {
                return this.saveButton.color;
            } else {
                return '#D2D5D9';
            }
        },
        hasErrors() {
            return Object.values(this.errors).filter((error) => error === true).length > 0;
        },
    },
    components: {
        Button,
        Dialog,
        ActionButton,
        ModelAutoComplete,
        ModelMultiAutoComplete,
        ModelString,
        ModelSelect,
        ModelISO,
        ModelCheckbox,
        ModelImg,
        ModelTextArea,
        FixedSaveBtn,
        ModelInterests,
    },

    watch: {
        savingConfirmation(v) {
            this.showSavingConfirmation = !!v;
        },

        '$store.state.account.userProfileInfo': {
            immediate: true,
            handler(value) {
                value && Object.keys(value).length && this.initUserInfo();
            },
        },

        userProfileName(next, prev) {
            if (prev && prev !== next) {
                this.$root.securityService.signinSilent();
            }
        },
    },

    methods: {
        ...mapActions(actions),
        ...mapMutations(mutations),
        checkName(val, fieldName) {
            return checkName(val, fieldName);
        },
        closeFixedBtn() {
            this.showFixedSaveBtn = false;
            this.observer ? this.observer.disconnect() : '';
        },
        changeIsPatronymic(value) {
            if (value) {
                this.profileInfo.patronymic = '';
            }
            this.errors.patronymic = !this.profileInfo.isPatronymic
                ? !!this.checkName(this.profileInfo.patronymic, 'Отчество')
                : false;
        },

        calcAge(dateString) {
            if (dateString === null) {
                return null;
            }
            return ageFromDate(new Date(dateString));
        },
        isYearError() {
            return !!this.dateOfBirthValidator(new Date(this.profileInfo.dateOfBirth));
        },

        async confirm() {
            return new Promise((resolve, reject) => {
                this.savingConfirmation = resolve;
            });
        },

        async saveBirthday() {
            if (this.calcAge(this.profileInfo.dateOfBirth) !== null) {
                this.saveData();
                this.showBirthdayBanner = false;
            }
        },

        async saveData() {
            if (this.saveButton.status != 'wait') return;
            this.saveButton.status = 'wait';
            this.saveButton.color = '#4663AB';
            this.saveButton.text = 'Сохранение...';
            this.saveButton.fixedText = 'Сохранение...';

            if (this.calcAge(this.profileInfo.dateOfBirth) < 18 && this.userProfileAge >= 18) {
                let confirm = await this.confirm();
                if (!confirm) {
                    this.saveButton.text = 'Сохранить';
                    this.saveButton.fixedText = 'Сохранить изменения';
                    this.saveButton.color = '#4663AB';
                    this.savingConfirmation = null;
                    return;
                }
                this.savingConfirmation = null;
            }

            try {
                let gender = null;
                if (this.profileInfo.gender === 'true') {
                    gender = true;
                } else if (this.profileInfo.gender === 'false') {
                    gender = false;
                }
                const postProfileQuery = await this.postProfileData({
                    ...this.profileInfo,
                    gender,
                });

                this.saveButton.status = 'wait';
                this.saveButton.color = '#238C47';
                this.saveButton.text = 'Данные сохранены';
                this.saveButton.fixedText = 'Данные сохранены';
                this.showFixedSaveBtn = false;
                this.observer ? this.observer.disconnect() : '';

                setTimeout(() => {
                    this.saveButton.text = 'Сохранить';
                    this.saveButton.fixedText = 'Сохранить изменения';
                    this.saveButton.color = '#4663AB';
                }, 2000);
            } catch (e) {
                if (e.message === 'Ошибки валидации полей: address - Укажите город или населенный пункт. ') {
                    this.addressErrorText = 'Укажи город или населенный пункт';
                }
                this.saveButton.status = 'wait';
                this.saveButton.color = '#F7E9F1';
                this.saveButton.text = 'Ошибка! извините..';
                this.saveButton.fixedText = 'Ошибка! извините..';

                setTimeout(() => {
                    this.saveButton.text = 'Сохранить';
                    this.saveButton.fixedText = 'Сохранить изменения';
                    this.saveButton.color = '#4663AB';
                }, 2000);
            }
        },
        async getAutocompleteAddress(inputObj) {
            this.addressErrorText = '';
            if (inputObj.value === '') {
                this.autoCompleteAddresses = [];
                return;
            }
            let postParams = [
                'dadata',
                'search',
                qs({ query: inputObj.value, type: 'address' }),
                true,
                { 'content-type': 'application/x-www-form-urlencoded' },
            ];
            let res = await post(...postParams);
            this.autoCompleteAddresses = res.suggestions;
        },
        async getFullAddress(item) {
            if (item.value === '') {
                this.profileInfo.address.data.federal_district = null;
                return;
            }
            let postParams = [
                'dadata',
                'clean',
                qs({ query: item.value, type: 'address' }),
                true,
                { 'content-type': 'application/x-www-form-urlencoded' },
            ];
            let res = await post(...postParams);
            this.profileInfo.address.data.federal_district = res.suggestions[0].data.federal_district;
        },
        async getAutocompleteActivity(inputObj) {
            if (inputObj.value.length > 0) {
                this.autoCompleteActivity = await this.dictionaryAutocomplete({
                    type: 'industries',
                    search: inputObj.value,
                });
            } else {
                this.autoCompleteActivity = await this.dictionaryByType('industries');
            }
        },
        async getAutocompleteInterests(inputObj) {
            if (inputObj.value.length >= 3) {
                const list = await this.dictionaryAutocomplete({
                    type: 'interests',
                    search: inputObj.value,
                });
                this.autoCompleteInterests = list;
            } else {
                this.autoCompleteInterests = await this.dictionaryByType('interests');
            }
        },
        async getAutocompleteKeySkills(inputObj) {
            if (inputObj.value.length >= 3) {
                const list = await this.dictionaryAutocomplete({
                    type: 'key_skills',
                    search: inputObj.value,
                });
                this.autoCompleteKeySkills = list;
            } else {
                this.autoCompleteKeySkills = await this.dictionaryByType('key_skills');
            }
        },
        loadSelectedActivity() {
            if (this.profileInfo.activity) {
                this.selectedActivity = this.dictionaryByType('industries').filter((v) =>
                    this.profileInfo.activity.includes(v.id)
                );
            }
        },
        loadSelectedInterests() {
            if (this.profileInfo.interests) {
                this.selectedInterests = this.profileInfo.interests;
            }
        },
        loadSelectedKeySkills() {
            if (this.profileInfo.keySkills) {
                this.selectedKeySkills = this.profileInfo.keySkills;
            }
        },
        initUserInfo() {
            this.showBirthdayBanner = this.userProfileAge === null;
            let userProfileInfo = JSON.parse(JSON.stringify(this.userProfileInfo));

            const cb1 = (key) => {
                // TODO валидацию firstJob и otherJobs
                if (this.profileInfo.hasOwnProperty(key)) {
                    if (key === 'gender') {
                        this.profileInfo[key] = userProfileInfo[key] != null ? userProfileInfo[key].toString() : null;
                    } else {
                        this.profileInfo[key] = userProfileInfo[key];
                    }
                }
            };
            Object.keys(this.userProfileInfo).forEach(cb1);
            this.loadSelectedActivity();
            this.loadSelectedInterests();
            this.loadSelectedKeySkills();
            this.loaded = true;
        },
    },
    async mounted() {
        await Promise.all([
            // Загрузить список сфер деятельности
            this.loadDictionaryItems('industries'),
            this.loadDictionaryItems('user_status'),
            // Загрузка ИТ-скиллов
            this.loadDictionaryItems('interests'),
            this.loadDictionaryItems('key_skills'),
            this.loadProfileData(),
        ]);

        this.autoCompleteActivity = this.dictionaryByType('industries');
        this.autoCompleteInterests = this.dictionaryByType('interests');
        this.autoCompleteKeySkills = this.dictionaryByType('key_skills');
        this.allInterests = this.dictionaryByType('interests');
        this.allKeySkills = this.dictionaryByType('key_skills');

        this.loadSelectedActivity();
        this.loadSelectedInterests();
        this.loadSelectedKeySkills();

        this.observer = await new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                !entry.isIntersecting && Math.sign(entry.boundingClientRect.top) === 1
                    ? (this.showFixedSaveBtn = true)
                    : (this.showFixedSaveBtn = false);
            });
        });
        this.$watch(
            'profileInfo',
            () => {
                this.observer.observe(this.$refs.mainBtn.$el);
            },
            { deep: true }
        );
    },
    beforeDestroy() {
        this.observer ? this.observer.disconnect() : '';
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/account-data.scss';

.data-wrapper {
    width: 100%;
    padding: 1.4rem;
    margin-bottom: rem(32);
    background: #ffffff;
    box-shadow: 0 0.3rem 0.5rem rgba(131, 134, 163, 0.12);
    border-radius: rem(10);
    min-height: 20rem;

    .main-data-wrapper {
        display: flex;
        flex-direction: row;

        .avatars {
            margin-right: rem(32);

            .main-avatar {
                margin-bottom: 1rem;
            }
        }

        .info {
            display: flex;
            flex-direction: column;
            width: 45rem;

            &.full {
                width: 100%;
            }

            .cols {
                display: flex;
                flex-direction: row;

                .col-info {
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                    margin-right: rem(32);
                }

                .col-info:last-child {
                    margin-right: 0;
                }
            }

            .chkbx {
                margin-bottom: rem(5);
            }
        }

        .present {
            margin-left: 1rem;
            background: #f2f2f2;
            flex: 1;
            border-radius: 0.25rem;
            display: flex;
            flex-direction: column;

            .present-awards-row {
                display: flex;
                flex-direction: row;
                justify-content: space-evenly;
                padding: rem(10) 0;

                img {
                    width: rem(80);
                    height: rem(80);
                }
            }
        }
    }
}

@import '../../../../styles/variables';

@media (max-width: $vm) {
    .data-wrapper {
        width: 100%;
        padding: 0;
        background: #ffffff;
        margin-bottom: 0;

        .main-data-wrapper {
            display: flex;
            flex-direction: column;
            padding: mrem(32) mrem(16) 0 mrem(16);

            .avatars {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                width: 100%;
                margin: 0 0 mrem(24) 0;

                .main-avatar {
                    margin: 0;
                }
            }

            .info {
                display: flex;
                flex-direction: column;
                width: 100%;

                .cols {
                    display: flex;
                    flex-direction: column;

                    .col-info {
                        display: flex;
                        flex-direction: column;
                        flex: 1;
                        margin: 0;

                        &:last-of-type {
                            margin-bottom: mrem(16);
                        }

                        .mb40 {
                            margin-bottom: rem(40);
                        }
                    }

                    .col-info:first-child {
                        padding-right: 0;
                    }

                    .col-info:last-child {
                        padding-left: 0;
                    }

                    .col-info:only-child {
                        padding: 0;
                    }
                }

                .chkbx {
                    margin-bottom: mrem(4);
                }
            }

            .present {
                margin-left: 1rem;
                background: #f2f2f2;
                flex: 1;
                border-radius: 0.25rem;
                display: flex;
                flex-direction: column;

                .present-awards-row {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-evenly;
                    padding: rem(10) 0;

                    img {
                        width: rem(80);
                        height: rem(80);
                    }
                }
            }
        }
    }
}

.birthdayBanner {
    h1 {
        font-style: normal;
        font-size: rem(28);
        line-height: rem(36);
        text-align: center;
        color: #2a2626;

        @media (max-width: $vm) {
            font-size: mrem(28);
            line-height: mrem(36);
        }
    }

    p {
        font-size: rem(18);
        line-height: rem(26);
        text-align: center;
        color: #2a2626;

        @media (max-width: $vm) {
            font-size: mrem(18);
            line-height: mrem(26);
        }
    }

    .btn {
        user-select: none;
        margin-top: rem(24);
        width: 50%;
        margin-right: auto;
        margin-left: auto;

        @media (max-width: $vm) {
            margin-top: mrem(24);
        }
    }

    .buttons {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
    }

    .btn-cancel,
    .btn-success {
        width: 46%;
    }
}
.info {
    :deep(.mt-invalid-text) {
        margin-top: mrem(-10);
        //padding: 0 10px 10px;
        font-size: mrem(12);
        font-weight: 500;
        line-height: mrem(18);
        text-align: left;
        color: #db6c61;
        @include on-desktop {
            margin-top: rem(-10);

            font-size: rem(12);
            line-height: rem(18);
            text-align: left;
        }
    }
}
</style>
